import { Typography } from "@mui/material";
import CriSection from "../../components/CriSection";

const Overview = () => {
  return (
    <CriSection>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 300,
        }}
      >
        Overview
      </Typography>

      <Typography
        sx={{
          fontWeight: 300,
          fontSize: "16px",
          lineHeight: 1.2,
          marginTop: "12px",
        }}
      >
        Our non-profit wildlife conservation organization offers a variety of
        educational resources to engage and inform the public about critical
        conservation efforts. These include published scientific papers,
        engaging speaking events featuring renowned experts, and informative
        books covering a range of conservation topics. Through these offerings,
        we aim to raise awareness and inspire action to protect wildlife and
        their habitats.
      </Typography>
    </CriSection>
  );
};

export default Overview;
